module.exports = __webpack_public_path__ + "static/media/user-circle.af80b87b.svg";